import { styled, Box, Typography, IconButton } from '@mui/material';

export const Container = styled(Box)({
  width: '100%',
  maxWidth: '100%',
  overflowX: 'hidden',
  height: 'calc(100vh - 160px)',
  display: 'flex',
  flexDirection: 'column',
  marginTop: '-12px',
});

export const FixedHeader = styled(Box)({
  flexShrink: 0,
});

export const HeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  marginBottom: 6,
  marginTop: '12px',
});

export const BackButton = styled(IconButton)({
  width: '35px',
  height: '35px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #DFDFDF',
  boxShadow: '0px 1px 3px rgba(0, 53, 114, 0.12)',
  borderRadius: '16px',
  '&:hover': {
    backgroundColor: '#F1F7FF',
  },
});

export const BackIcon = styled('i')({
  fontSize: '20px',
  color: '#75838A',
});

export const Title = styled(Typography)({
  fontFamily: 'Lufga',
  fontWeight: 500,
  fontSize: '25px',
  lineHeight: '100%',
  color: '#0F52BA',
});

export const Description = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '100%',
  color: '#75838A',
  marginBottom: 16,
  marginLeft: 56, // Adjusted from 52 to match the +4px from HeaderRow
});

export const ContentBox = styled(Box)({
  marginTop: 10,
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});
